import React from "react";

import { SectionRetryButton } from "../../../../components/SectionRetryButton";
import { formatObservedAt } from "../../utils/format";
import { UnavailableBody } from "./styles";
import { SectionUnavailableProps } from "./types";

export const SectionUnavailable: React.FC<SectionUnavailableProps> = ({
  observedAt,
  onRetry,
}) => (
  <UnavailableBody role="status">
    <span>Unavailable · last observed {formatObservedAt(observedAt)}</span>
    <SectionRetryButton onClick={onRetry} />
  </UnavailableBody>
);
